import React, {FC, useEffect, useState} from "react";
import { DoctorDto } from "@apiModels/DoctorDto.csharp";
import { LocationDto } from "../../../../../Api/Model/LocationDto.csharp";
import {SvgIcon} from "../../../SvgIcon/SvgIcon";
import {Divider} from "../../Divider/Divider";
import {Collapse} from "react-collapse";
import classNames from "classnames";

type DoctorCardProps = {
  doctor: DoctorDto;
  centers: LocationDto[];
};

const DOCTOR_BIO_ID = "doctorBio"

export const DoctorCard: FC<DoctorCardProps> = ({ doctor, centers }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { name, pictureUrl, bio, jobTitle, centers: doctorCenters, areasOfExpertise } = doctor;

  const supportedCenters = centers.filter((center) =>
    doctorCenters.includes(center.id)
  );

  const [bioFirstPart, ...bioRest] = (bio ?? "")
    .split("</p>")
    .filter((p) => !!p);

  useEffect(() => {
    setIsOpen(false);
  }, [doctor]);
  
  const areasOfExpertiseParagraph = areasOfExpertise ? `<p><em>Behandlingsområder:</em><br>${areasOfExpertise}</p>` : "";
  const doctorBioWithAreasOfExpertise = bioRest.filter((part) => part.length != 0).join("</p>") + "</p>" + areasOfExpertiseParagraph;
  
  return (
    <div className={classNames( 
        "DoctorCard", 
        {"DoctorCard--open": isOpen},
        )}>
      <div className="DoctorCard__summary">
        <div className="DoctorCard__info">
          <div className="DoctorCard__avatar" >
            <img
                src={pictureUrl + "?width=216&height=216&rmode=crop&ranchor=top"}
                alt=""
            />
          </div>
          <div>
            <h4 className="DoctorCard__name">{name}</h4>
            <div className="DoctorCard__location">
              <ul className="DoctorCard__location__list">
                {supportedCenters.map((center, index, array) => (
                  <li key={center.id}>
                    {center.name}
                    {index < array.length -1 ? ', ' : ''}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        
        {bioRest.length > 0 && 
          <button 
            className="DoctorCard__iconButton"  
            type="button" 
            onClick={() => setIsOpen(!isOpen)} 
            aria-expanded={isOpen} 
            aria-controls={DOCTOR_BIO_ID}
            aria-label="Toggle description"
          >
            <SvgIcon iconName="chevron-down" className="DoctorCard__icon" />
          </button>
        }
      </div>

      <p className="DoctorCard__jobTitle">{jobTitle}</p>

      {bioFirstPart && (
        <div className="DoctorCard__bio" id={DOCTOR_BIO_ID}>
          
          <div className="DoctorCard__firstSection">
            <div dangerouslySetInnerHTML={{ __html: bioFirstPart + "</p>" }} />
            
            {bioRest.length > 0 && !isOpen && (
              <button 
                className="DoctorCard__firstSection__button"
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                aria-hidden
              />
            )}
          </div>
  
          {bioRest.length > 0 && (
            <>
              {!isOpen && <div className="DoctorCard__transparentGradient" />}
              <Collapse theme={{ collapse: "react-collapse--collapse" }} isOpened={isOpen}>
                <div dangerouslySetInnerHTML={{ __html: doctorBioWithAreasOfExpertise }}/>
              </Collapse>
            </>
          )}
  
        </div>
      )}

      <Divider className="DoctorCard__divider"/>
    </div>
  );
};
